import { useMutation, useQueryClient } from "@tanstack/react-query";
import { billingApi } from "../api/billingApi";
import { BILLING_STATUS_KEY } from "./useBillingStatusQuery";

export function useCancelSubscriptionMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: billingApi.cancel,
    onSuccess: (status) => {
      queryClient.setQueryData(BILLING_STATUS_KEY, status);
      queryClient.invalidateQueries({ queryKey: ["auth", "me"] });
    },
  });
}
